import type { StreamProvider } from '@vgtv/api-client';

/**
 * Returns the hostname of Schibsted Video Portal for the given provider.
 */
function getPortalHostname(provider: StreamProvider | 'brandstudio') {
  if (provider === 'ab') {
    return 'tv.aftonbladet.se';
  }

  if (provider === 'vgtv') {
    return 'tv.vg.no';
  }
}

export { getPortalHostname };
